import {Enum} from 'enumify'

class UpSellIconType extends Enum {}
UpSellIconType.initEnum({
  SPRING_SEASONAL_TASK: {
    iconsrc: 'springcleanup',
    bgsrc: 'proposal-images/spring-cleanup-proposed.png',
    apiName: 'SPRING_SEASONAL_TASK',
    bgcolor: 'springcleanup-background',
    prettify: 'SPRINGCLEANUP'
  },
  FALL_SEASONAL_TASK: {
    iconsrc: 'fallcleanup',
    bgsrc: 'upsells/fall-cleanup.png',
    apiName: 'FALL_SEASONAL_TASK',
    bgcolor: 'fallcleanup-background',
    prettify: 'FALLCLEANUP'
  },
  AERATION_TASK: {
    iconsrc: 'aeration',
    bgsrc: 'proposal-images/aeration-proposed.png',
    apiName: 'AERATION_TASK',
    bgcolor: 'aeration-background',
    prettify: 'AERATELAWN'
  },
  FERTILIZATION_TASK: {
    iconsrc: 'fertilization',
    bgsrc: 'proposal-images/fertilization-proposed.png',
    apiName: 'FERTILIZATION_TASK',
    bgcolor: 'fertilization-background',
    prettify: 'FERTILIZELAWN'
  },
  LAWN_MOWING_NEW_TASK: {
    iconsrc: 'lawnmowing',
    bgsrc: 'upsells/lawn-mowing.png',
    apiName: 'LAWN_MOWING_NEW_TASK',
    bgcolor: 'mowlawn-background',
    prettify: ''
  },
  LAWN_MOWING_FREQUENCY: {
    iconsrc: 'lawnmowing',
    bgsrc: 'upsells/lawn-mowing.png',
    apiName: 'LAWN_MOWING_FREQUENCY',
    bgcolor: 'mowlawn-background',
    prettify: ''
  },
  LAWN_MOWING_SERVICE_PACKAGE: {
    iconsrc: 'lawnmowing',
    bgsrc: 'upsells/lawn-mowing.png',
    apiName: 'LAWN_MOWING_SERVICE_PACKAGE',
    bgcolor: 'mowlawn-background',
    prettify: ''
  },
  SNOW_CLEARING_NEW_TASK: {
    iconsrc: 'lawnmowing',
    bgsrc: 'upsells/snow-removal.png',
    apiName: 'SNOW_CLEARING_NEW_TASK',
    bgcolor: 'plowsnow-background',
    prettify: ''
  }
})

export function getUpSellIconType (apiName) {
  for (const type of UpSellIconType.enumValues) {
    if (type.apiName === apiName) {
      return type
    }
  }
}

export default UpSellIconType



// WEBPACK FOOTER //
// ./src/components/shared/enums/upsell-icon-type.js